import { isMasterUser, readStoredUser } from './authSession';
import { formatDate } from './formatters';
import {
    loadPrinterSnapshot,
    loadPrinterSnapshotDataUrl,
    resolvePrinterUuid,
} from './printerSnapshotStorage';
import { hasProAccess } from './subscription';

/** Master ou plano Pro — únicos que veem snapshot da câmera (Farm Link). */
export function canShowPrinterFarmLinkSnapshot(user = readStoredUser()) {
    return isMasterUser(user) || hasProAccess(user?.plan_name);
}

export const PRINTER_SNAPSHOT_TOOLTIP =
    'O Farm Link envia automaticamente, de tempos em tempos, uma foto da câmera de cada impressora que tiver câmera conectada. Quando houver imagem disponível, ela aparece aqui.';

export { resolvePrinterUuid, loadPrinterSnapshotDataUrl, loadPrinterSnapshot };

/**
 * URL/data URL do snapshot: localStorage (último recebido) ou campo da API, se existir.
 */
export function printerSnapshotUrl(printer) {
    if (!printer || typeof printer !== 'object') {
        return null;
    }
    const uuid = resolvePrinterUuid(printer);
    const stored = loadPrinterSnapshotDataUrl(uuid);
    if (stored) {
        return stored;
    }
    const raw = printer.snapshot_url ?? printer.snapshotUrl ?? '';
    const url = String(raw || '').trim();
    return url || null;
}

/** Tooltip quando há snapshot; null usa o texto explicativo padrão. */
export function printerSnapshotCapturedTooltip(updatedAt) {
    if (!updatedAt) {
        return null;
    }
    const formatted = formatDate(updatedAt, true);
    if (!formatted || formatted === 'N/A' || formatted === 'Data inválida') {
        return null;
    }
    return `Imagem capturada em ${formatted}.`;
}
